/** List of known Procore error messages returned by the Procore API */
export const PROCORE_ERROR_MESSAGES = {
  appNotConnected: "App is not connected to this company"
};